import React, { Component } from "react";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,

    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
    Row
} from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import { throttle } from "lodash";
import { LinkContainer } from 'react-router-bootstrap';
import { LOGO, SITE_TITLE } from "../../../../constants";
import AuthButton from "./AuthButton";


class Header extends Component {
    constructor(props) {
        super(props);
        const navbarHeight = 'auto';
        this.state = {
            isLoggedIn: false,
            collapsed: true,
            halfWidth: window.innerWidth,
            navbarHeight: 1000
        };
        this.calculateNavbarExtendedColor = this.calculateNavbarExtendedColor.bind(this);

    }

    componentDidMount() {
        this.navbarTime = setTimeout(this.calculateNavbarExtendedColor, 500);
        window.addEventListener("resize", this.calculateNavbarExtendedColor);
    }
    componentWillUnmount() {
        clearTimeout(this.navbarTime);
        window.removeEventListener("resize", this.calculateNavbarExtendedColor);
    }


    calculateNavbarExtendedColor() {
        let windowWidth = document.documentElement.clientWidth;
        let container = document.querySelector(".container").clientWidth;
        let remWidth = windowWidth - container;
        this.navbarHeight = document.querySelector(".navbar").clientHeight;

        this.setState({
            halfWidth: (remWidth / 2) + 116,
            navbarHeight: this.navbarHeight
        })
    }
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed
        });
    };
    refresh = () => {
        const wWidth = window.innerWidth;
        if(wWidth < 992){
            this.setState({
                collapsed: !this.state.collapsed
            });
        }
    }
    render() {
        let { isLoggedIn } = this.state;
        return (

            <Navbar expand="lg">
              
                    
                <div className="navbar-extended-color" style={{ width: this.state.halfWidth + "px", maxHeight: this.state.navbarHeight + "px" }}></div>
       
                    <div className="container-lg">
                        <div className="d-lg-flex align-items-center justify-content-between -mx-16">
                            <NavbarBrand href="/">
                                <img src={LOGO} alt={SITE_TITLE + "_LOGO"} title={SITE_TITLE} />
                            </NavbarBrand>
                            <NavbarToggler onClick={this.toggle} className={!this.state.collapsed ? 'active' : ''} />
                            <Collapse isOpen={!this.state.collapsed} className="ml-auto" navbar>
                                <Nav className="ml-auto" navbar>
                                    <NavItem>
                                        <NavLink to="/" 
                                        className={({ isActive }) =>
                                        isActive ? 'active' : undefined
                                    } onClick={this.refresh}>Home</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink to="/about" onClick={this.refresh}>About us</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink to="/services" onClick={this.refresh}>Services</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink to="/contact" onClick={this.refresh}>Contact us</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink to="/career" onClick={this.refresh}>Careers</NavLink>
                                    </NavItem>
                                </Nav>

                                <div className="navbar-info">
                                    <div className="item">
                                        <a href="tel: +1 949-345-0787">
                                            <i className="icon-phone" /> +1 (949) 345-0787 </a>
                                    </div>
                                    <div className="item">
                                        <a href="mailto:admin@aeritech.com">
                                            <i className="icon-envelope" /> admin@aeritech.com </a>
                                    </div>
                                </div>

                                <div className="navbar-quote">
                                    <div className="item">
                                        <AuthButton isLoggedIn={isLoggedIn} refresh={this.refresh} />
                                    </div>
                                    <div className="item">
                                        <Link to="/contact" onClick={this.refresh}>Get a Quote</Link>
                                    </div>
                                </div>
                            </Collapse> 
                        </div>
                    </div>
         
            </Navbar>

        );
    }
}

export default Header;
